export default "__VITE_ASSET__BgA8w1hE__"